export const walletIds = {
    blocto: '14e7176536cb3706e221daaa3cfd7b88b7da8c7dfb64d1d241044164802c6bdd',
    ledger: '19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927',
};
